import React from 'react';
import PropTypes from 'prop-types';

import UploaderFile from './UploaderFile';
import FileInput from './FileInput';

class Uploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: []
    };
  }

  render() {
    const fileComponents = this.state.files.map((file, key) => (
      <div key={key}>
        <UploaderFile
          file={file}
          onUploading={this.props.onUploading || this.noOp}
          onUploaded={this.props.onUpload || this.noOp}
          onError={this.props.onError || this.noOp} />
      </div>
    ));

    return (
      <div>
        <FileInput onChange={this.onChange.bind(this)} filetypes={this.props.filetypes} />
        {fileComponents}
      </div>
    );
  }

  onChange(event) {
    const files = [...event.target.files];

    if (!this.props.onChange) {
      this.upload(files);
      return;
    } else {
      this.props.onChange(files, this.upload.bind(this));
    }
  }

  upload(files) {
    this.setState({
      files: this.state.files.concat(files)
    });
  }

  noOp() {}
}

Uploader.defaultProps = {
  filetypes: '*'
};

Uploader.propTypes = {
  filetypes: PropTypes.string,
  onChange: PropTypes.func,
  onUploading: PropTypes.func,
  onUpload: PropTypes.func,
  onError: PropTypes.func
};

export default Uploader;
